import { render, staticRenderFns } from "./courseApp.vue?vue&type=template&id=66d4f435&scoped=true&"
import script from "./courseApp.vue?vue&type=script&lang=js&"
export * from "./courseApp.vue?vue&type=script&lang=js&"
import style0 from "./courseApp.vue?vue&type=style&index=0&id=66d4f435&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d4f435",
  null
  
)

export default component.exports